export const MIXPANEL_EVENT_TITLE = {
    CLICKED_GUIDE_LINK: 'Clicked Guide link',
    CLICKED_SEE_MORE_GUIDES: 'Clicked See More Guides',
};
